<template>
  <div class="my-order" ref="container">
    <div class="header">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">訂單信息</div>
          <div>
            累計訂單：{{ orderData.order_count || 0 }} 總消費：￥{{
              orderData.sum_price || 0
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="nav acea-row row-between">
      <div
        class="item"
        :class="{ on: type === 1 }"
        @click="$router.replace({ path: '/order/list/1' })"
      >
        <div>待發貨</div>
        <div class="num">{{ orderData.unshipped_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 2 }"
        @click="$router.replace({ path: '/order/list/2' })"
      >
        <div>待收貨</div>
        <div class="num">{{ orderData.received_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 3 }"
        @click="$router.replace({ path: '/order/list/3' })"
      >
        <div>待評價</div>
        <div class="num">{{ orderData.evaluated_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 4 }"
        @click="$router.replace({ path: '/order/list/4' })"
      >
        <div>已完成</div>
        <div class="num">{{ orderData.complete_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === -1 }"
        @click="$router.replace({ path: '/order/list/-1' })"
      >
        <div>退款</div>
        <div class="num">{{ orderData.refund_count || 0 }}</div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0"
              >拼团</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.seckill_id > 0"
              >秒杀</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.bargain_id > 0"
              >砍价</span
            >
            {{ order._add_time }}
          </div>
          <div class="order-state">{{ getStatus(order) }}</div>
        </div>
        <div @click="$router.push({ path: '/order/detail/' + order.order_id })">
          <div
            class="item-info acea-row row-between row-top"
            v-for="cart in order.cartInfo"
            :key="cart.id"
          >
            <div class="pictrue">
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                "
                v-if="
                  cart.combination_id === 0 &&
                    cart.bargain_id === 0 &&
                    cart.seckill_id === 0
                "
              />
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({
                    path: '/activity/group_detail/' + cart.combination_id
                  })
                "
                v-else-if="cart.combination_id > 0"
              />
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({
                    path: '/activity/dargain_detail/' + cart.bargain_id
                  })
                "
                v-else-if="cart.bargain_id > 0"
              />
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({
                    path: '/activity/seckill_detail/' + cart.seckill_id
                  })
                "
                v-else-if="cart.seckill_id > 0"
              />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ cart.productInfo.store_name }}
              </div>
              <div class="money">
                <div>
                  ￥{{
                    cart.productInfo.attrInfo
                      ? cart.productInfo.attrInfo.price
                      : cart.productInfo.price
                  }}
                </div>
                <div>x{{ cart.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ order.cartInfo.length || 0 }}件商品，總金額
          <span class="money font-color-red">￥{{ order.pay_price }}</span>
        </div>
        <div class="bottom acea-row row-right row-middle">
          <template
            v-if="order._status._type === 0 || order._status._type == 9"
          >
            <div class="bnt cancelBnt" @click="cancelOrder(order)">
              取消訂單
            </div>
          </template>
          <template v-if="order._status._type === 0">
            <div class="bnt" @click="paymentTap(order)">
              立即付款
            </div>
            <!--
            <template v-if="userInfo.certification_type === 2">
              <div class="bnt bg-color-red" @click="paymentTap(order)">
                立即付款
              </div>
            </template>
            -->
            <!--
            <template v-else>
              <div
                class="bnt bg-color-red"
                v-if="order.isAgree === 0"
                @click="tellMessage"
              >
                审核中
              </div>
              <div
                class="bnt bg-color-red"
                @click="paymentTap(order)"
                v-else-if="order.isAgree === 1"
              >
                立即付款
              </div>
              <div
                class="bnt bg-color-yellow"
                @click="openReason(order.remark, order.order_id)"
                v-else
              >
                审核未通过
              </div>
            </template>
            -->
          </template>
          <template
            v-if="order._status._type === 1 || order._status._type === 9"
          >
            <div
              class="bnt"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              查看詳情
            </div>
          </template>
          <template v-if="order._status._type === 2">
            <div
              class="bnt default"
              @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              "
              v-if="order.delivery_type === 'express'"
            >
              查看物流
            </div>
            <div class="bnt" @click="takeOrder(order)">
              確認收貨
            </div>
          </template>
          <template v-if="order._status._type === 3">
            <div
              class="bnt default"
              @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              "
              v-if="order.delivery_type === 'express' && order.delivery_id"
            >
              查看物流
            </div>
            <div
              class="bnt"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              去評價
            </div>
          </template>
          <template v-if="order._status._type === 4">
            <div
              class="bnt"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              查看訂單
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/moblie/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
    <ChangePrescriptionImg
      :order_id="order_id"
      :showReason="showReason"
      :reason="reason"
      @changeShow="changeShow"
    ></ChangePrescriptionImg>
  </div>
</template>
<script>
import { getOrderData, getOrderList,checkRepurchase2,  orderDetail } from "@api/order";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/moblie/Loading";
import Payment from "@components/moblie/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import GeneralWindow from "@components/moblie/GeneralWindow";
import ChangePrescriptionImg from "@components/moblie/ChangePrescriptionImg";

const STATUS = [
  "待付款",
  "待發貨",
  "待收貨",
  "待評價",
  "已完成",
  "待審核",
  "",
  "",
  "",
  "",
  "待付款"
];

const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: isWeixin()? ["weixin", "alipay"] : ["yue", "alipay"],
      from: isWeixin()? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      showReason: false,
      order_id: 0,
      reason: "",
      isQuestionnaire: false,
    };
  },
  components: {
    Loading,
    Payment,
    GeneralWindow,
    ChangePrescriptionImg
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getOrderData();
      }
    }
  },
  methods: {
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getOrderData() {
      getOrderData().then(res => {
        this.orderData = res.data;
      });
    },
    takeOrder(order) {
      takeOrderHandle(order.order_id).then(res => {
        if (
          (res.data.gain_integral != "0.00" &&
            res.data.gain_coupon != "0.00") ||
          (res.data.gain_integral > 0 && res.data.gain_coupon > 0)
        ) {
          this.generalActive = true;
          this.generalContent = {
            promoterNum: `恭喜您獲得${res.data.gain_coupon}元優惠券以及${
              res.data.gain_integral
            }積分，購買商品時可抵現哦～`,
            title: "恭喜您獲得優惠禮包"
          };
          return;
        } else if (
          res.data.gain_integral != "0.00" ||
          res.data.gain_integral > 0
        ) {
          this.generalActive = true;
          this.generalContent = {
            promoterNum: `恭喜您獲得${
              res.data.gain_integral
            }積分，購買商品時可抵現哦～`,
            title: "贈送積分"
          };
          return;
        } else if (res.data.gain_coupon != "0.00" || res.data.gain_coupon > 0) {
          this.generalActive = true;
          this.generalContent = {
            promoterNum: `恭喜您獲得${
              res.data.gain_coupon
            }元優惠券，購買商品時可抵現哦～`,
            title: "恭喜您獲得優惠券"
          };
          return;
        } else {
          this.$dialog.success("收貨成功");
        }
        this.getOrderData();
        this.orderList = [];
        this.page = 1;
        this.loaded = false;
        this.loading = false;
        this.getOrderList();
      });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload() {
      this.changeType(this.type);
    },
    checkRepurchase(order) {
      checkRepurchase2().then(res => {
         console.log(1111122222);
         orderDetail(order.order_id).then(res2 => {
        if (res.data.status === "SUCCESS"&&res2.data.isQuestionnaire == 0){

          return (window.location.href = `https://h5.unoeclinic.com/v2/#/article/wzQuestionnaire?order_id=${
          order.order_id
        }&type=wechat&user_id=${order.uid}`);
        }
        })
      });
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getOrderList({
        page,
        limit,
        type
      }).then(res => {
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    getStatus(order) {
      return STATUS[order._status._type];
    },
    cancelOrder(order) {
      cancelOrderHandle(order.order_id)
        .then(() => {
          this.getOrderData();
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    paymentTap: function(order) {
      console.log("list");
      console.log(order);
      console.log(this.userInfo);
      let cartList = [];
      order.cartInfo.forEach(item => {
        cartList.push(item.productInfo.id + "");
      });
      console.log(cartList);
      if (
        order.isQuestionnaire == 0
      ) {
        this.pay = false;
      console.log(5555550032);
         checkRepurchase2().then(res => {
         console.log(1111122222);

         orderDetail(order.order_id).then(res2 => {
         console.log('订单详情')
         console.log(res2)
        if (res.data.status === "SUCCESS"&&res2.data.isQuestionnaire == 0){

          return (window.location.href = `https://h5.unoeclinic.com/v2/#/article/wzQuestionnaire?order_id=${
          order.order_id
        }&type=wechat&user_id=${order.uid}`);
        }
        })
      });
      return 1;
      }
      var that = this;
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.toPay = type => {
        console.log('订单号：'+order.order_id)
        console.log('付款方式：'+type)
        console.log('客户端：'+that.from)
        payOrderHandle(order.order_id, 'weixin', 'weixin')
          .then(() => {
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          })
          .catch(res => {
            console.log("payOrderHandleError");
            if (res.status === "WECHAT_H5_PAY")
              return that.$router.push({
                path: "/order/status/" + order.order_id + "/5"
              });
            const type = parseInt(that.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          });
      };
    },
    toPay() {},
    tellMessage() {
      this.$dialog.toast({
        mes: "您的處方認證正在審核中，通過後會顯示支付按鈕！"
      });
    },
    openReason(data, id) {
      this.order_id = id;
      this.reason = data || "您所提交的處方圖品不符合，需重新提交！";
      this.showReason = true;
    },
    changeShow(data) {
      this.showReason = data;
    }
  },
  mounted() {
    //从外部链接获取
    let url = window.location.href;
    let dz_url = url.split("#")[0];
    let cs = dz_url.split("?")[0];
    let cs_arr = cs.split("&");
    let cs_obj = {};
    for (let i = 0; i < cs_arr.length; i++) {
      cs_obj[(cs_arr[i].split("=")[0] = cs_arr[i].split("=")[1])];
    }
    this.isQuestionnaire = cs_obj.isQuestionnaire;
    this.getOrderData();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.bg-color-yellow {
  background: #666;
}

.order-state {
  color: rgb(104, 137, 221);
}
</style>
